import { render, staticRenderFns } from "./SeniorStudio.vue?vue&type=template&id=15fbe3b9&"
import script from "./SeniorStudio.vue?vue&type=script&lang=js&"
export * from "./SeniorStudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports